

















































import { utils } from '@easygenerator/fragment-sdk';
import { Component, Vue } from 'vue-property-decorator';
import PasswordField from './common/PasswordField.vue';
import CommonForm from './common/CommonForm.vue';
import { BAD_REQUEST_EXCEPTION } from '../utils/constants';
import Config from '../config';
const config = Config.getInstance();

@Component({
  components: {
    PasswordField,
    CommonForm
  }
})
export default class ForgotPassword extends Vue {
  showLinkExpired = false;

  password = '';

  confirmationEmailSent = false;

  emailToConfirm: string | null = '';

  state: string | null = '';

  isPasswordInvalid = false;

  disableSubmit = true;

  updatePassword(value: string) {
    this.password = value;
  }

  getValueFromQueryString(key = 'token') {
    const urlParams = new URLSearchParams(window.location.search);

    return urlParams.get(key);
  }

  async checkState(state: string) {
    try {
      const response = await utils.HttpWrapper.get(`/api/credentials/state-exists?state=${state}`);
      return response.exists;
    } catch (e) {
      return false;
    }
  }

  async beforeMount() {
    const state = this.getValueFromQueryString('state');
    if (!state) {
      this.showLinkExpired = true;
      return;
    }
    try {
      const stateExists = await this.checkState(state);
      this.showLinkExpired = !stateExists;
    } catch (err) {
      this.showLinkExpired = true;
    }
  }

  passwordValid(value: boolean) {
    this.disableSubmit = !value;
  }

  created() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('email')) {
      this.emailToConfirm = urlParams.get('email');
    }

    if (urlParams.has('state')) {
      this.state = urlParams.get('state');
    }
  }

  async submitForm(): Promise<void> {
    try {
      const url = '/api/credentials/change-password';

      const data = {
        state: this.state,
        password: this.password
      };

      const { returnUrl } = await utils.HttpWrapper.post(url, {
        body: data,
        headers: { accept: 'application/json' }
      });

      window.open(returnUrl, '_self');
    } catch (err) {
      if (err.status >= BAD_REQUEST_EXCEPTION) {
        this.showLinkExpired = true;
      }
    }
  }

  async goToLogin(): Promise<void> {
    window.open(config.learnServiceUrl, '_self');
  }
}
